import { categories, navItems } from '@/mocks/heiliao';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 text-background-200">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500">
                <span className="font-heading text-lg font-black text-background-50">44</span>
              </div>
              <div>
                <span className="block font-heading text-xl font-black text-background-50">黑料区</span>
                <span className="block text-[11px] tracking-wider text-background-400">
                  话题目录 · 标签导航
                </span>
              </div>
            </div>
            <p className="mt-5 text-xs leading-relaxed text-background-400">
              以目录方式整理娱乐舆论公开话题，按明星、网红、政商、社会等标签分区归类，帮助读者按分类高效查找。
            </p>
          </div>

          <nav aria-label="分区目录导航">
            <h2 className="font-heading text-sm font-bold text-background-50">分区目录</h2>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href="#categories"
                    className="text-xs text-background-400 transition-colors hover:text-accent-400"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="站内导航">
            <h2 className="font-heading text-sm font-bold text-background-50">站内导航</h2>
            <ul className="mt-4 space-y-2.5">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="text-xs text-background-400 transition-colors hover:text-accent-400"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#subscribe"
                  className="text-xs text-background-400 transition-colors hover:text-accent-400"
                >
                  订阅与联系
                </a>
              </li>
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-sm font-bold text-background-50">联系与声明</h2>
            <ul className="mt-4 space-y-2.5 text-xs text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                contact@44-heiliao.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                工作日 10:00 - 19:00
              </li>
            </ul>
            <p className="mt-4 border-l-2 border-primary-600 pl-3 text-[11px] leading-relaxed text-background-500">
              本站仅整理公开可见、可回溯的信息，不代表任何立场，也不针对真实个人发布评价性结论。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[11px] text-background-500">
            © {year} 44黑料区 · 娱乐舆论话题分类目录。保留所有权利。
          </p>
          <ul className="flex flex-wrap items-center gap-x-5 gap-y-2 text-[11px] text-background-500">
            <li>
              <a href="#about" className="transition-colors hover:text-accent-400">
                关于我们
              </a>
            </li>
            <li>
              <a href="#faq" className="transition-colors hover:text-accent-400">
                常见问答
              </a>
            </li>
            <li>
              <a href="#subscribe" className="transition-colors hover:text-accent-400">
                内容纠错
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}